export const selectorPeticioDonarDeBaixaEstacioEnCurs = state => state.estacio.peticioDonarDeBaixaEstacioEnCurs;



// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_peticio_donar_de_baixa_estacio_en_curs.js